import React from 'react'
import "./greenRibbon.css"

const greenRibbon = () => {
  return (
    <React.Fragment>
        <div className="green-bookmark">
            <div className="green-bookmark-text">
                <h3>แลกเลย !</h3>
            </div>
        </div>
    </React.Fragment>
    )
}

export default greenRibbon;
